import React from 'react'
import Note from '../Components/note'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import {
  addToNotes,
  getNotes
} from '../Actions/actions'

const mapStateToProps = (state) => {
  return {
    notes: state.notes
  }
}

class Notes extends React.Component {

  syncToDB = e => {
    e.preventDefault();
    const { dispatch, notes } = this.props
    const notesToSync = _.filter(notes, { 'sync': false });
    dispatch(addToNotes(notesToSync))
    dispatch(getNotes())
  }

  getNotesFromDB = e => {
    console.log('Get the notes from Firebase ...and update the state')
    e.preventDefault();
    const { dispatch } = this.props
    dispatch(getNotes())
  }

  render() {
    const { notes } = this.props;
    const online = navigator.onLine

    if (!notes.length) {
      return (
        <section className="section">
          <div className="container">
            <img src="/imgs/oh-no.gif" alt="Oh no animated" />
            <h1 className="title">No notes!</h1>
            <h2 className="subtitle">No notes have been added yet</h2>
            <p>When you are ready you can <Link to="create">create some</Link>{online ? " or" : "."} <a href="#" className={online ? "is-link" : "is-hidden"} onClick={this.getNotesFromDB}> download past notes</a></p>

          </div>
        </section>
      )
    }

    let orderedNotes = _.orderBy(notes, ['created', 'location'], ['desc', 'asc'])
    return (
      <section className="section">
        <div className="container">
          <h1 className="title">
            Past Notes
          </h1>
          <h2 className="subtitle">
            The notes in your collection. The newest are on the top.
          </h2>
          <p className={online ? "server-actions has-text-centered" : "is-hidden"}>
            <a href="#" className="button is-info is-outlined" onClick={this.syncToDB}>Sync New Notes to Server</a>
            <a href="#" className="button is-info is-success is-outlined" onClick={this.getNotesFromDB}>Get Notes from Server</a>
          </p>
          <ul>
            {orderedNotes.map((note, i) => (
               <Note key={i} {...note} />
             ))}
          </ul>
        </div>
      </section>
    )
  }
}

export default connect(mapStateToProps)(Notes)



// WEBPACK FOOTER //
// ./src/Pages/notes.js